/** Siglas dos estados brasileiros em ordem alfabética */
export const UF_LIST = [
  "AC",
  "AL",
  "AM",
  "AP",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MG",
  "MS",
  "MT",
  "PA",
  "PB",
  "PE",
  "PI",
  "PR",
  "RJ",
  "RN",
  "RO",
  "RR",
  "RS",
  "SC",
  "SE",
  "SP",
  "TO",
];

/** Nomes dos meses em português */
/** Labels de status das reclassificações de monta */
export const LAUDO_STATUS_LABELS: Record<string, string> = {
  rascunho: "Rascunho",
  em_vistoria: "Em Vistoria",
  em_avaliacao_rt: "Avaliação RT",
  em_auditoria: "Em Auditoria",
  finalizado: "Finalizado",
};

/** Classes de cor por status dos laudos */
export const LAUDO_STATUS_COLORS: Record<string, string> = {
  rascunho: "bg-slate-100 text-slate-700",
  em_vistoria: "bg-amber-100 text-amber-700",
  em_avaliacao_rt: "bg-purple-100 text-purple-700",
  em_auditoria: "bg-blue-100 text-blue-700",
  finalizado: "bg-green-100 text-green-700",
};

/** Labels de papel (role) dos usuários */
export const ROLE_LABELS: Record<string, string> = {
  owner: "Owner",
  admin: "Administrador",
  rt: "Responsável Técnico",
  tv: "Técnico de Vistoria",
  parceiro_negocios: "Solicitante",
  auditor: "Auditor",
};

/** Classes de cor por papel (role) dos usuários */
export const ROLE_BADGE_COLORS: Record<string, string> = {
  owner: "bg-red-100 text-red-700",
  admin: "bg-blue-100 text-blue-700",
  rt: "bg-purple-100 text-purple-700",
  tv: "bg-amber-100 text-amber-700",
  parceiro_negocios: "bg-orange-100 text-orange-700",
  auditor: "bg-teal-100 text-teal-700",
};

/** Lista de todos os roles disponíveis */
export const ALL_ROLES = [
  "owner",
  "admin",
  "rt",
  "tv",
  "parceiro_negocios",
  "auditor",
] as const;

/** Labels do tipo de empresa */
export const EMPRESA_TIPO_LABELS: Record<string, string> = {
  OWNER: "CEO",
  VISTORIADORA: "Vistoriadora",
  PARCEIRO_DE_NEGOCIOS: "Solicitante",
};

/** Labels do tipo de veículo */
export const VEICULO_TIPO_LABELS: Record<string, string> = {
  auto_leve: "Auto / Leve / Caminhonete",
  moto: "Moto",
  caminhao: "Caminhão",
  onibus: "Ônibus",
};

/** Labels dos tipos de foto do veículo (Laudo de Avaliação) */
export const TIPO_FOTO_LABELS: Record<string, string> = {
  veiculo_frente: "Frente",
  veiculo_traseira: "Traseira",
  veiculo_lateral_esq: "Lateral esquerda",
  veiculo_lateral_dir: "Lateral direita",
  veiculo_interior: "Interior / painel",
  veiculo_km: "Quilometragem",
  veiculo_motor: "Compartimento do motor",
  veiculo_identificacao: "Identificação do veículo",
  veiculo_45_dianteira_esq: "Dianteira 45° esquerda",
  veiculo_45_dianteira_dir: "Dianteira 45° direita",
  veiculo_45_traseira_esq: "Traseira 45° esquerda",
  veiculo_45_traseira_dir: "Traseira 45° direita",
  dano: "Avaria",
};

export const RECLASSIFICACAO_VISTAS = [
  "veiculo_frente",
  "veiculo_traseira",
  "veiculo_lateral_dir",
  "veiculo_lateral_esq",
  "veiculo_45_dianteira_esq",
  "veiculo_45_dianteira_dir",
  "veiculo_45_traseira_esq",
  "veiculo_45_traseira_dir",
] as const;

export const RECLASSIFICACAO_RESPOSTA_LABELS = {
  sim: "SIM",
  nao: "NÃO",
  na: "NA",
} as const;

/** Labels da classificação de porte (Laudo de Avaliação) */
export const CLASSIFICACAO_PORTE_LABELS: Record<string, string> = {
  pequena_monta: "Pequena Monta",
  media_monta: "Média Monta",
  grande_monta: "Grande Monta",
};

/** Classes de cor por tipo de veículo */
export const VEICULO_TIPO_COLORS: Record<string, string> = {
  auto_leve: "bg-blue-100 text-blue-700",
  moto: "bg-purple-100 text-purple-700",
  caminhao: "bg-orange-100 text-orange-700",
  onibus: "bg-green-100 text-green-700",
};

/** Labels de condição dos elementos estruturais */
/** Classes de cor por condição dos elementos estruturais */
/** Cores de veículos (tabela de cores RENAVAM) */
export const CORES: { codigo: string; nome: string; hex: string | null }[] = [
  { codigo: "01", nome: "Amarelo", hex: "#FFD600" },
  { codigo: "02", nome: "Azul", hex: "#1565C0" },
  { codigo: "03", nome: "Bege", hex: "#F5DEB3" },
  { codigo: "04", nome: "Branca", hex: "#F0F0F0" },
  { codigo: "05", nome: "Cinza", hex: "#9E9E9E" },
  { codigo: "06", nome: "Dourada", hex: "#FFD700" },
  { codigo: "07", nome: "Grená", hex: "#6B0000" },
  { codigo: "08", nome: "Laranja", hex: "#FF6D00" },
  { codigo: "09", nome: "Marrom", hex: "#5D4037" },
  { codigo: "10", nome: "Prata", hex: "#BDBDBD" },
  { codigo: "11", nome: "Preta", hex: "#212121" },
  { codigo: "12", nome: "Rosa", hex: "#EC407A" },
  { codigo: "13", nome: "Roxa", hex: "#7B1FA2" },
  { codigo: "14", nome: "Verde", hex: "#2E7D32" },
  { codigo: "15", nome: "Vermelha", hex: "#D32F2F" },
  { codigo: "16", nome: "Fantasia", hex: null },
];

/** Marcas de veículos por tipo */
export const MARCAS_POR_TIPO: Record<string, string[]> = {
  auto_leve: [
    "Fiat",
    "Volkswagen",
    "Chevrolet",
    "Ford",
    "Toyota",
    "Honda",
    "Renault",
    "Hyundai",
    "Jeep",
    "Nissan",
    "Peugeot",
    "Citroën",
    "BMW",
    "Mercedes-Benz",
    "Audi",
    "Volvo",
    "Kia",
    "Mitsubishi",
    "Subaru",
    "Land Rover",
    "Porsche",
    "Mini",
    "RAM",
    "BYD",
    "JAC",
    "Caoa Chery",
    "HAVAL",
    "GWM",
    "Lifan",
    "Dodge",
  ],
  moto: [
    "Honda",
    "Yamaha",
    "Suzuki",
    "Kawasaki",
    "BMW",
    "Harley-Davidson",
    "Triumph",
    "Ducati",
    "KTM",
    "Royal Enfield",
    "CF Moto",
    "Benelli",
    "Dafra",
    "Haojue",
    "TVS",
    "Shineray",
    "Zongshen",
    "Kasinski",
  ],
  caminhao: [
    "Mercedes-Benz",
    "Volkswagen",
    "Volvo",
    "Scania",
    "MAN",
    "DAF",
    "Iveco",
    "Ford",
    "Agrale",
    "Foton",
    "JAC",
    "Hyundai",
    "Effa",
    "Sinotruk",
    "Dongfeng",
    "Hino",
    "Tata",
    "International",
  ],
  onibus: [
    "Mercedes-Benz",
    "Volkswagen",
    "Volvo",
    "Scania",
    "MAN",
    "Agrale",
    "Iveco",
    "Neobus",
    "Marcopolo",
    "Busscar",
    "Comil",
  ],
};

/** Labels de status das transações financeiras */
/** Classes de cor por status das transações financeiras */
/** Categorias de transações financeiras */
/** Labels dos status dos elementos estruturais (CONTRAN 810/2020) */
export const ELEMENTO_STATUS_LABELS: Record<string, string> = {
  integro: "Íntegro",
  danificado: "Danificado",
  substituido: "Substituído",
  reparado: "Reparado",
  inexistente: "Inexistente",
  nao_avaliado: "Não avaliado",
};

/** Classes de cor por status dos elementos estruturais */
export const ELEMENTO_STATUS_COLORS: Record<string, string> = {
  integro: "bg-emerald-100 text-emerald-700",
  danificado: "bg-red-100 text-red-700",
  substituido: "bg-blue-100 text-blue-700",
  reparado: "bg-amber-100 text-amber-700",
  inexistente: "bg-slate-100 text-slate-500",
  nao_avaliado: "bg-gray-100 text-gray-500",
};

/** Labels da conclusão técnica do laudo */
export const CONCLUSAO_LABELS: Record<string, string> = {
  recuperavel: "Recuperável",
  irrecuperavel: "Irrecuperável",
};

/** Classes de cor da conclusão técnica do laudo */
export const CONCLUSAO_COLORS: Record<string, string> = {
  recuperavel: "bg-green-100 text-green-700",
  irrecuperavel: "bg-red-100 text-red-700",
};

/** Labels da classificação do nexo causal (Reclassificação) */
export const NEXO_CLASSIFICACAO_LABELS: Record<string, string> = {
  confirmado: "Confirmado",
  provavel: "Provável",
  parcial: "Parcial",
  inconclusivo: "Inconclusivo",
  nao_demonstrado: "Não demonstrado",
  incompativel: "Incompatível",
};

/** Classes de cor da classificação do nexo causal (Reclassificação) */
export const NEXO_CLASSIFICACAO_COLORS: Record<string, string> = {
  confirmado: "bg-green-100 text-green-700",
  provavel: "bg-emerald-100 text-emerald-700",
  parcial: "bg-amber-100 text-amber-700",
  inconclusivo: "bg-slate-100 text-slate-700",
  nao_demonstrado: "bg-orange-100 text-orange-700",
  incompativel: "bg-red-100 text-red-700",
};

/** Labels das categorias de itens do orçamento técnico de viabilidade */
export const ORCAMENTO_CATEGORIA_LABELS: Record<string, string> = {
  peca: "Peça",
  mao_de_obra: "Mão de obra",
  funilaria: "Funilaria",
  pintura: "Pintura",
  mecanica: "Mecânica",
  eletrica: "Elétrica",
  diagnostico: "Diagnóstico",
  calibracao: "Calibração",
  alinhamento: "Alinhamento",
  transporte: "Transporte",
  terceiros: "Terceiros",
  tributos: "Tributos",
  nao_coberto: "Não coberto",
};

/** Labels de status dos itens do orçamento técnico de viabilidade */
export const ORCAMENTO_STATUS_LABELS: Record<string, string> = {
  proposto: "Proposto",
  aprovado: "Aprovado",
  aprovado_com_ajuste: "Aprovado com ajuste",
  devolvido: "Devolvido",
  reprovado: "Reprovado",
};

/** Classes de cor por status dos itens do orçamento técnico de viabilidade */
export const ORCAMENTO_STATUS_COLORS: Record<string, string> = {
  proposto: "bg-slate-100 text-slate-700",
  aprovado: "bg-green-100 text-green-700",
  aprovado_com_ajuste: "bg-amber-100 text-amber-700",
  devolvido: "bg-orange-100 text-orange-700",
  reprovado: "bg-red-100 text-red-700",
};

/** Labels dos tipos de ocorrência da timeline do dossiê */
export const OCORRENCIA_TIPO_LABELS: Record<string, string> = {
  divergencia: "Divergência",
  correcao: "Correção",
  auditoria: "Auditoria",
  observacao: "Observação",
  orcamento: "Orçamento",
};

/** Classes de cor por tipo de ocorrência da timeline do dossiê */
export const OCORRENCIA_TIPO_COLORS: Record<string, string> = {
  divergencia: "bg-orange-100 text-orange-700",
  correcao: "bg-amber-100 text-amber-700",
  auditoria: "bg-blue-100 text-blue-700",
  observacao: "bg-slate-100 text-slate-700",
  orcamento: "bg-purple-100 text-purple-700",
};
